import {
    CircularProgress,
    Tab,
    Tabs,
    Avatar,
    Box,
    Button,
    Container,
    CssBaseline,
    Grid,
    TextField,
    Typography,
    Alert,
    ThemeProvider,
    useTheme,
} from "@mui/material";
import {
    ChangeEvent,
    SyntheticEvent,
    useContext,
    useEffect,
    useState,
} from "react";
import {
    Link,
    Redirect,
    useHistory,
    useLocation,
    useParams,
} from "react-router-dom";
import { S3Service } from "../../services-old/S3Service";
import { getOrgPublicSettings, loginUser } from "../../services-old/me.service";
import { APIRequestStatus, basePath, INITIAL_FEEDBACK } from "../constants";
import { Lock } from "@mui/icons-material";
import { Superadmin_Service } from "../../services/superadmin/superadmin-service";
import { Admin_Service } from "../../services/admin/admin-service";
import UserContext, { IOrgadmin, User_Type } from "../UserContext";
import { UseIsUserLogged } from "../../hooks/use-is-user-logged";

function Copyright(props: any) {
    return (
        <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            {...props}
        >
            {"Copyright © "}
            <Link color="inherit" to="/">
                Zama School
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

type Props = {
    redirectionUrl?: string;
    onLoginSuccess?: (res: any[]) => void;
    loginButtonLabel?: string;
    onlyShowInputs?: boolean;
};

const initial_creds = { username: "", password: "" };

export default function SignIn({
    redirectionUrl,
    onLoginSuccess,
    loginButtonLabel,
    onlyShowInputs,
}: Props) {
    const theme = useTheme();
    const [status, setStatus] = useState({
        message: "",
        severity: "success",
        hidden: true,
    });
    const [settings, setSettings] = useState<any>({});
    const [orgLogoURL, setOrgURL] = useState(`${basePath}/icon.png`);
    const [loginStatus, setLoginStatus] = useState(APIRequestStatus.idle);
    const [creds, set_creds] = useState(initial_creds);
    const [org_code, set_org_code] = useState("");
    const location = useLocation();
    const history = useHistory();
    // const { org } = useParams<any>();
    const { setUser, user, setPermissions } = useContext(UserContext);
    const params = useParams<{ user_type: User_Type }>();
    const { feedback: is_logged_feedback } = UseIsUserLogged();

    const handle_submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoginStatus(APIRequestStatus.loading);

        const [data, error] = await (params.user_type === User_Type.Superadmin
            ? Superadmin_Service.login_superadmin(creds)
            : Admin_Service.login_admin(creds, org_code));

        console.log({ data, error });

        if (error) {
            // if (error.message == "Already logged in") {
            //     history.replace(`/${params.user_type}/`);
            // }
            setLoginStatus(APIRequestStatus.error);
            setStatus({
                message: error.message,
                severity: "error",
                hidden: false,
            });
        } else {
            setLoginStatus(APIRequestStatus.success);
            setStatus({
                message: "Login successfull",
                severity: "success",
                hidden: false,
            });

            if (data?.admin) setUser(data.admin);

            if (data?.admin) history.replace(`/${params.user_type}/`);

            const is_org_admin =
                data?.admin && data.admin.user_type === User_Type.Admin;

            setPermissions(
                is_org_admin
                    ? (data?.admin as IOrgadmin).role.permissions.map(
                          (item) => item.op.name
                      )
                    : []
            );

            // if (userLoginData.user.baseUser.type == "employee") {
            //     history.push("/payment");
            // } else if (userLoginData.user.baseUser.type == "user") {
            //     history.push("/dashboard");
            // }
        }

        // if (onLoginSuccess) onLoginSuccess([userLoginData, userLoginError]);
    };

    // const getOrgSettings = async () => {
    //     const [data, err] = await getOrgPublicSettings(org);

    //     if (data) {
    //         const setts: any = {};

    //         data.settings.forEach((s: any) => {
    //             setts[s["key"]] = s["value"];
    //         });
    //         setSettings(setts);
    //     }
    // };

    const getOrgLogo = async () => {
        if (settings["organization-logo"]) {
            const url = await S3Service.getS3ByKey(
                settings["organization-logo"]
            );
            setOrgURL(url);
        }
    };

    function handle_creds(event: ChangeEvent<HTMLInputElement>) {
        set_creds((curr) => ({
            ...curr,
            [event.target.name]: event.target.value,
        }));
    }

    useEffect(() => {
        getOrgLogo();
    }, [settings]);

    if (!Object.values(User_Type).includes(params.user_type))
        return <Redirect to={"/admin/login"} />;

    if (is_logged_feedback.loading)
        return (
            <Box
                height="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <CircularProgress />
            </Box>
        );

    return (
        // <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xl">
            {/* <CssBaseline /> */}

            <Grid
                container
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    minHeight: "100vh",
                }}
                // item
                // lg={12}
            >
                {/* {!onlyShowInputs && (
                        <Hidden smDown>
                            <Grid item lg={6}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <h1>{`Welcome to ${
                                        settings["organization-name"] ||
                                        "Accounts Book "
                                    }`}</h1>
                                </div>
                            </Grid>
                        </Hidden>
                    )} */}

                <Grid item xs={12} md={6} lg={6}>
                    <Box
                        sx={{
                            // marginTop: 70,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {settings["organization-logo"] ? (
                            <img
                                src={orgLogoURL}
                                alt="logo"
                                style={{
                                    maxWidth: "48x",
                                    maxHeight: "48px",
                                }}
                            />
                        ) : (
                            !onlyShowInputs && (
                                <Avatar
                                    style={{
                                        margin: theme.spacing(1),
                                        backgroundColor:
                                            theme.palette.primary.main,
                                    }}
                                >
                                    <Lock />
                                </Avatar>
                            )
                        )}

                        {!onlyShowInputs && (
                            <Typography component="h1" variant="h5">
                                {settings["organization-name"]
                                    ? `${settings["organization-name"]} Sign in`
                                    : "Sign in"}
                            </Typography>
                        )}

                        <Box component="form" onSubmit={handle_submit}>
                            {params.user_type === User_Type.Admin && (
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="org_code"
                                    label="Organization Code"
                                    variant="outlined"
                                    onChange={(e) =>
                                        set_org_code(e.target.value)
                                    }
                                    value={org_code}
                                />
                            )}

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                // type="email"
                                label="Username"
                                name="username"
                                autoComplete="email"
                                autoFocus
                                variant="outlined"
                                value={creds.username}
                                onChange={handle_creds}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                variant="outlined"
                                onChange={handle_creds}
                                value={creds.password}
                            />

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={
                                    loginStatus === APIRequestStatus.loading
                                }
                                style={{
                                    marginTop: theme.spacing(1),
                                    marginBottom: theme.spacing(0.5),
                                }}
                                endIcon={
                                    loginStatus === APIRequestStatus.loading ? (
                                        <CircularProgress
                                            size="1rem"
                                            color="primary"
                                        />
                                    ) : (
                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-zjt8k"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                            data-testid="LoginIcon"
                                            tabIndex={-1}
                                            // title="Login"
                                        >
                                            <path d="M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"></path>
                                        </svg>
                                    )
                                }
                            >
                                {loginButtonLabel ?? "Login"}
                            </Button>
                            {/* <Button
                            fullWidth
                            variant="contained"
                            style={{
                                marginTop: theme.spacing(3),
                                marginBottom: theme.spacing(2),
                            }}
                            href="/api/user/auth/google/login"
                        >
                            Signin with Google
                        </Button> */}
                            <section hidden={status.hidden}>
                                <Alert severity={status.severity as any}>
                                    {status.message}
                                </Alert>
                            </section>

                            {/* {!onlyShowInputs && (
                                    <Grid
                                        item
                                        style={{
                                            marginTop: theme.spacing(2),
                                            textAlign: "center",
                                        }}
                                    >
                                        <Link
                                            href="/signup"
                                            variant="body2"
                                            color="textPrimary"
                                            style={{ width: "100%" }}
                                        >
                                            Don't have an account? Sign Up
                                        </Link>
                                    </Grid>
                                )} */}
                        </Box>
                    </Box>

                    <Copyright style={{ margin: theme.spacing(5) }} />
                </Grid>
            </Grid>
        </Container>
        // </ThemeProvider>
    );
}
